<template>
  <v-dialog
    v-model="internalDialog"
    overlay-opacity="0.8"
    :width="width"
    :dark="isDarkMode"
    class="dialog"
    transition="fade-transition"
    :persistent="disabled"
  >
    <template v-if="button" v-slot:activator="{ on }">
      <span @click="activatorClicked()">
        <slot name="activator">
          <button
            class="numerai-button"
            :class="{
              'full-width': fullWidth,
              round: buttonClass === 'round',
            }"
            :title="disabled ? disabledTooltip : enabledTooltip"
            :enabled-tooltip="enabledTooltip"
          >
            {{ buttonText }}
          </button>
        </slot>
      </span>
    </template>
    <div class="modal-container" :style="`background-color: ${color};`">
      <div v-if="!hideHeader" class="modal-group pb-0">
        <slot name="header">
          <h2 class="title">{{ title }}</h2>
        </slot>
      </div>
      <div
        class="modal-group pt-0"
        :class="{ 'pb-0': showFooter, 'pa-0': noPadding }"
      >
        <slot></slot>
      </div>
      <div
        v-if="showFooter & !loading"
        class="modal-group buttons-container pt-2"
      >
        <slot name="footer">
          <button
            :disabled="disabled"
            class="numerai-button button-tertiary"
            :class="{ 'pa-0': !saveCallback }"
            @click="close"
          >
            Close
          </button>
          <button
            v-if="saveCallback"
            :disabled="disabled"
            class="numerai-button ml-4"
            @click="save"
          >
            {{ saveButtonText }}
          </button>
        </slot>
      </div>
      <div v-if="loading" class="modal-group buttons-container pt-2">
        <NumeraiLoader />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import NumeraiLoader from '@/components/shared/NumeraiLoader'

export default {
  components: {
    NumeraiLoader,
  },
  props: {
    width: { type: Number, default: 500 },
    title: { type: String, default: '' },
    buttonText: { type: String, default: '' },
    disabledTooltip: { type: String, default: '' },
    enabledTooltip: { type: String, default: '' },
    saveButtonText: { type: String, default: 'Confirm' },
    saveCallback: { type: Function, default: null },
    fullWidth: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    activatedCallback: { type: Function, default: null },
    showFooter: { type: Boolean, default: true },
    border: { type: String, default: '' },
    color: { type: String, default: 'var(--background-color)' },
    buttonClass: { type: String, default: null },
    dialog: { type: Boolean, default: false },
    button: { type: Boolean, default: true },
    hideHeader: { type: Boolean, default: false },
    noPadding: { type: Boolean, default: false },
  },
  data() {
    return { internalDialog: this.dialog }
  },
  computed: {
    ...mapGetters(['isDarkMode']),
  },
  watch: {
    dialog(val) {
      if (val) {
        this.internalDialog = true
        this.$emit('open')
      } else {
        this.internalDialog = false
        this.$emit('close')
      }
    },
    internalDialog(val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  methods: {
    open() {
      this.internalDialog = true
    },
    close() {
      this.internalDialog = false
    },
    save() {
      this.$emit('save')
      if (this.saveCallback) {
        this.saveCallback()
      }
    },
    // Called when the modal's activator is clicked
    activatorClicked() {
      this.internalDialog = true
      if (this.activatedCallback) {
        this.activatedCallback()
      }
    },
  },
}
</script>
<style scoped lang="scss">
.modal-container {
  font-size: 0.9rem;
  color: var(--color-secondary);
}

.modal-group {
  padding: 30px 30px 30px 30px;
}

.buttons-container {
  padding: 15px 30px;
  display: flex;
  justify-content: flex-end;
}

.link {
  text-decoration: underline;
}
</style>
